import { render, staticRenderFns } from "./BaseColorPicker.vue?vue&type=template&id=0e5ac4d8&"
import script from "./BaseColorPicker.vue?vue&type=script&lang=js&"
export * from "./BaseColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./BaseColorPicker.vue?vue&type=style&index=0&id=0e5ac4d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports